// extracted by mini-css-extract-plugin
export var backdrop = "navbar-desktop-module--backdrop--a8d45";
export var buttonItem = "navbar-desktop-module--buttonItem--74940";
export var chevron = "navbar-desktop-module--chevron--45c31";
export var item = "navbar-desktop-module--item--eb498";
export var link = "navbar-desktop-module--link--51d0d";
export var linkWrapper = "navbar-desktop-module--linkWrapper--e6dc3";
export var menu = "navbar-desktop-module--menu--14c86";
export var navBtn = "navbar-desktop-module--navBtn--94d74";
export var navbar = "navbar-desktop-module--navbar--652d3";